import Navbar from "./components/Navbar";
import SearchZone from "./components/SearchZone";
import SearchPanel from "./components/SearchPanel";

function App() {
  return (
    <div className="App">
      <Navbar />
      <SearchZone />
      <SearchPanel />
    </div>
  );
};

export default App;